export default "__VITE_ASSET__5d8f845e__"